import React from 'react';

// Order placed — a calm, reassuring confirmation with the order number, the
// fulfilment method, the total, and what happens next.

const CheckCircle = () => (
  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M5 12.5l4.2 4.2L19 7" />
  </svg>
);

const ProductConfirmation = ({ order, currency = '£', salonName, onClose, onContinue }) => {
  if (!order) return null;
  const isShip = order.delivery && order.delivery.method === 'ship';
  const firstName = (order.customer.name || '').split(' ')[0] || 'there';

  return (
    <div className="ps-confirm">
      <span className="ps-confirm-check" aria-hidden><CheckCircle /></span>
      <h2 className="ps-confirm-title">Order confirmed</h2>
      <p className="ps-confirm-sub">Thanks {firstName}, your order is in and paid.</p>

      <div className="ps-confirm-card">
        <div className="ps-confirm-row"><span>Order</span><strong>{order.number}</strong></div>
        <div className="ps-confirm-row"><span>{isShip ? 'Delivery' : 'Collection'}</span><strong>{isShip ? 'Ship to you' : `Collect from ${salonName || 'the salon'}`}</strong></div>
        <div className="ps-confirm-row"><span>Total paid</span><strong>{currency}{Number(order.total).toFixed(2)}</strong></div>
      </div>

      <p className="ps-confirm-next">
        {isShip
          ? 'We will email a confirmation now, and tracking as soon as it ships.'
          : 'We will email a confirmation now, and let you know the moment it is ready to collect.'}
      </p>

      <button type="button" className="ps-btn ps-btn--primary ps-btn--lg" onClick={onClose}>Done</button>
      <button type="button" className="ps-btn ps-btn--text" onClick={onContinue}>Continue shopping</button>
    </div>
  );
};

export default ProductConfirmation;
